<template>
  <div class="modal" @keydown.enter="handleEnterKey" @keydown.esc="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h1>Create function</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('close')"
                aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="submitFunction">
          <div class="mb-3">
            <label for="code" class="form-label">Code</label>
            <input type="text" class="form-control" id="code" v-model="functionData.code" ref="codeInput" required
                   placeholder="Short function code"/>
          </div>
          <div class="mb-3">
            <label for="name" class="form-label">Description</label>
            <input type="text" class="form-control" id="name" v-model="functionData.description" required
                   placeholder="Function description"/>
          </div>
          <!-- Add button to indicate if function needs to be published or not -->
          <div class="form-check ">
            <label for="published" class="form-check-label">Published</label>
            <input type="checkbox" class="form-check-input" value="" id="published" v-model="functionData.published"
                   placeholder="Published" checked/>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="$emit('close')">Cancel</button>
        <button type="submit" class="btn btn-primary" :disabled="isSubmitButtonDisabled" @click="submitFunction">
          Create function
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateFunctionModal',
  props: {
    subLocationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      functionData: {
        code: '',
        name: '',
        sub_location_id: this.subLocationId,
      },
    };
  },
  computed: {
    isSubmitButtonDisabled() {
      return this.functionData.code === '' || this.functionData.description === '';
    },
  },
  mounted() {
    this.$refs.codeInput.focus();
  },
  methods: {
    submitFunction() {
      this.$emit('create-function', this.functionData);
      this.$emit('close');
    },
    handleEnterKey() {
      if (!this.isCreateButtonDisabled) {
        this.submitFunction();
      }
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
</style>